<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="6" offset-lg="3">
        <BaseTitle class="mt-16 mb-6">
          {{ $t('Sign in title')}}
        </BaseTitle>
        <BaseParagraph class="text-center mb-1">
          {{ $t('Registration hint') }}
        </BaseParagraph>
        <div class="text-center mb-8">
          <router-link to="/inscription">
            Ouvrir mon espace personnel
          </router-link>
        </div>
        <form @submit.prevent="submit">
          <v-text-field v-model="email" :label="$t('Email')" type="email" required />
          <v-text-field
            v-model="password"
            :label="$t('Password')"
            :type="showPassword ? 'text' : 'password'"
            required
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          />
          <div class="text-center mb-8">
            <router-link to="/mot-de-passe-oublie">
              {{ $t('Password forgotten')}}
            </router-link>
          </div>
          <v-btn color="primary" block bottom type="submit">
            Me connecter
          </v-btn>
        </form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';
import BaseParagraph from '@/components/BaseParagraph.vue';
import { mapFields } from 'vuex-map-fields';
import { mapActions, mapMutations } from 'vuex';
import { VUE_APP_API_URL } from '@/constants';

export default {
  name: 'SignIn',
  components: {
    BaseTitle,
    BaseParagraph,
  },
  data() {
    return {
      showPassword: false,
    };
  },
  created() {
    const { origin } = new URL(VUE_APP_API_URL);
    if (window.parent) {
      window.parent.postMessage('loaded', '*');
    }
    window.addEventListener('message', (e) => {
      if (e.origin === origin && e.data.Authorization) {
        localStorage.authorization = e.data.Authorization;
        window.location.href = '/';
      }
    });
  },
  computed: mapFields('authentication', ['form.email', 'form.password']),
  methods: {
    ...mapActions('authentication', ['signIn']),
    ...mapMutations(['setAlert']),
    submit() {
      this.signIn()
        .then(() => {
          this.$router.push('/');
        })
        .catch((error) => {
          if (error.toString().includes('Network Error')) {
            this.setAlert({ text: 'Serveur indisponible', color: 'warning', show: true });
          } else if (error.response.status === 401) {
            if (error.response.data.error === 'Vous devez confirmer votre compte pour continuer.') {
              this.$router.push('/compte-en-attente');
            } else if (error.response.data.error === "Votre compte n'est pas encore activé.") {
              this.setAlert({
                text: "Votre compte est bloqué ou en cours d'activation. Veuillez contacter le secrétariat pour plus d'informations",
                color: 'warning',
                show: true,
              });
            } else {
              this.setAlert({
                text: 'Email ou mot de passe incorrect',
                color: 'warning',
                show: true,
              });
            }
          } else if (error.response.status === 403) {
            if (error.response.data.error === 'Accounting problem') {
              this.setAlert({
                text: 'URGENT : Problème comptable, merci de contacter le service comptabilité à compta@excosup.fr',
                color: 'error',
                show: true,
              });
            }
          }
        });
    },
  },
};
</script>
